import { ChartType } from "../../models/charts/chart-type.enum";
import { AnomaliesComponent } from "../components/anomalies.component";
export class AnomaliesFactory {
    instantiate(element: HTMLElement, type: ChartType) {
        return new AnomaliesComponent(element, type)
    }
}